// extracted by mini-css-extract-plugin
export var text = "_19-0";